import React, { useState, useEffect } from 'react';
import './index.css';

const NewsPage = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL
    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${apiUrl}blogs/news/`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const data = await response.json();
                setNews(data);
            } catch (err) {
                console.error('Error:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const truncateHtml = (html, maxLength) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        let truncated = div.textContent || div.innerText || '';
        if (truncated.length > maxLength) {
            truncated = truncated.substring(0, maxLength) + '...';
        }
        return truncated;
    };

    return (
        <div className="news-page">
            <h1 className='news-item'>News</h1>
            <ul>
                {news.map((item) => {
                    const imageUrl = `${apiUrl}${item.image}`;
                    console.log(imageUrl);
                    return (
                        <li key={item.id} className="news-item">
                            <img src={imageUrl} alt={item.title} className="news-image" />
                            <div className="news-details">
                                <h2>{item.title}</h2>
                                <p dangerouslySetInnerHTML={{ __html: truncateHtml(item.description, 1000) }} />
                                <p><strong>Author:</strong> {item.author}</p>
                                <p><strong>Published on:</strong> {new Date(item.publication_date).toLocaleDateString()}</p>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};  

export default NewsPage;
